export default __webpack_public_path__ + "static/assets/0eb768b38e74f776ee7557dc07ddcbfb.jpg";